import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const PingSteps = ()=>{
    const { t: pingTexts } = useLocaleKeys('integrations.setup.ping');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepOpenIntegrations()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepPasteApiKey()
            })
        ]
    });
};
